@switch (method()) {
  @case (withdrawalMethodIdEnum.Paypal) {
    <iw-paypal-form [form]="form()" />
  }
  @case (withdrawalMethodIdEnum.CardPersonal) {
    <iw-card-personal-form [form]="form()" />
  }
  @case (withdrawalMethodIdEnum.ADVCash) {
    <iw-advcash-form [form]="form()" />
  }
  @case (withdrawalMethodIdEnum.BankTransferINR) {
    <iw-bank-transfer-inr-form [form]="form()" />
  }
  @case (withdrawalMethodIdEnum.CODEOffice) {
    <iw-code-office-form [form]="form()" />
  }
  @case (withdrawalMethodIdEnum.Crypto) {
    <iw-crypto-form [form]="form()" />
  }
}
